export default {
  getMyPrograms: state => state.myProgramsCollection,
  getAllPrograms: state => state.allProgramsCollection,
  justAddedPatientData: state => state.justAddedPatientData
}
